import { render, staticRenderFns } from "./CamaraEnVivoOperaciones.vue?vue&type=template&id=4807237f&scoped=true&"
import script from "./CamaraEnVivoOperaciones.vue?vue&type=script&lang=ts&"
export * from "./CamaraEnVivoOperaciones.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraEnVivoOperaciones.vue?vue&type=style&index=0&id=4807237f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4807237f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4807237f', component.options)
    } else {
      api.reload('4807237f', component.options)
    }
    module.hot.accept("./CamaraEnVivoOperaciones.vue?vue&type=template&id=4807237f&scoped=true&", function () {
      api.rerender('4807237f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/EnVivo/CamaraEnVivoOperaciones.vue"
export default component.exports